import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hello, I would like to inquire about your Civil Litigation services.");
    window.open(`https://wa.me/254721320787?text=${message}`, '_blank');
  };

  const handleCallClick = () => {
    window.open('tel:+254721320787', '_self');
  };

  return (
    <section className="relative bg-gradient-to-br from-surface/20 to-primary/10 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-2xl">
                <Icon name="Scale" size={32} color="white" strokeWidth={2} />
              </div>
              <div>
                <h1 className="text-4xl lg:text-5xl font-heading font-bold text-text-primary">
                  Civil Litigation
                </h1>
                <p className="text-text-secondary font-caption mt-1">
                  Courtroom Excellence & Strategic Advocacy
                </p>
              </div>
            </div>

            <p className="text-lg text-text-secondary leading-relaxed">
              Exceptional courtroom expertise and dispute resolution capabilities that build client confidence in complex legal proceedings. Our strategic approach combines litigation experience with settlement negotiation skills to achieve optimal outcomes.
            </p>

            {/* Contact Actions */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="primary"
                onClick={handleWhatsAppClick}
                iconName="MessageCircle"
                iconPosition="left"
                size="lg"
                className="flex-1 sm:flex-none"
              >
                WhatsApp Consultation
              </Button>
              
              <Button
                variant="outline"
                onClick={handleCallClick}
                iconName="Phone"
                iconPosition="left"
                size="lg"
                className="flex-1 sm:flex-none"
              >
                Call Now
              </Button>
            </div>

            {/* Contact Info */}
            <div className="flex items-center space-x-6 text-sm text-text-secondary">
              <div className="flex items-center space-x-2">
                <Icon name="Phone" size={16} />
                <span>+254 721 320 787</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Mail" size={16} />
                <span>info@peterpartnerslaw.co.ke</span>
              </div>
            </div>
          </div>

          {/* Visual Element */}
          <div className="relative">
            <div className="aspect-square bg-gradient-to-br from-primary/20 to-accent/20 rounded-3xl p-8 flex items-center justify-center">
              <div className="w-full h-full bg-white rounded-2xl shadow-lg flex items-center justify-center">
                <Icon name="Scale" size={120} color="var(--color-primary)" strokeWidth={1.5} />
              </div>
            </div>
            
            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-accent rounded-2xl flex items-center justify-center shadow-lg">
              <Icon name="Gavel" size={32} color="white" strokeWidth={2} />
            </div>
            
            <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-secondary rounded-2xl flex items-center justify-center shadow-lg">
              <Icon name="CheckCircle" size={24} color="var(--color-text-primary)" strokeWidth={2} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;